var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrganic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#77BA3F;}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "organic"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ll",
    className: "st0",
    d: "M20,4.4c8.6,0,15.6,7,15.6,15.6c0,7.4-5.1,13.4-11.9,15.1c-0.9-9.7-2.5-10.9-2.5-10.9  c0.6,2.1-0.4,9.4-0.7,11.3c-0.2,0-0.4,0-0.6,0c-8.6,0-15.6-7-15.6-15.6S11.4,4.4,20,4.4z M11.4,24.1c0.5,7.6,6.2,6.7,8.2,6.1  c-0.5-0.7-1.9-2.3-3.8-3.1c0,0,3,0.8,4.3,1.8C18.9,21.3,11.4,24.1,11.4,24.1z M19.7,23.1c0-1.4-0.3-4.6-1.8-7.3  c0,0,3.2,4.3,3.8,6.6c6.3-9.6-7.9-14.7-7.9-14.7C9,21.8,16.3,23.2,19.7,23.1z M23.6,26.2c0.6-1.3,3.7-3.6,3.7-3.6  c-1.5,1.5-2.3,3.6-2.5,4.3c8,1.1,7.2-8.8,7.2-8.8C23.2,18.2,23.3,24.4,23.6,26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "oo_4_",
    d: "M20,2c9.9,0,18,8.1,18,18s-8.1,18-18,18S2,29.9,2,20S10.1,2,20,2z M20,35.6c8.6,0,15.6-7,15.6-15.6  S28.6,4.4,20,4.4S4.4,11.4,4.4,20S11.4,35.6,20,35.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganic);
export default __webpack_public_path__ + "static/media/organic.d48b8745bba80ad31af88371c57ddb82.svg";
export { ForwardRef as ReactComponent };